<div class="row" *ngIf="!selfVisitor">
    <div class="col-md-12">
        <app-util-visitor-parts-treatment-injection-list-filter
                                            [selfVisitor]="selfVisitor"
                                            (filterEvent)="filterVisitorTreatments($event)"></app-util-visitor-parts-treatment-injection-list-filter>
    </div>
</div>
<div class="row mt-5">
    <div class="col-md-12 align-items-center justify-content-space-between">
        <h5 class="title mb-3">
            <ng-container *ngIf="!archived">
                {{ 'VISITORS_MEDICAL.TREATMENT_INJECTIONS_IN_PROGRESS' | translate }}
            </ng-container>
            <ng-container *ngIf="archived">
                {{ 'VISITORS_MEDICAL.TREATMENT_INJECTIONS_HISTORY' | translate }}
            </ng-container>
        </h5>
        <ng-container *ngxPermissionsOnly="'cudVisitorTreatment'">
            <div *ngIf="!archived">
                <button type="button"
                        class="btn btn-primary btn-fill"
                        (click)="utilVisitorPartsTreatmentInjectionModalsAdd.openModal(visitor?.id)">
                    <i class="fa fa-plus"></i> {{ 'VISITORS_MEDICAL.ADD_TREATMENT_INJECTION' | translate }}
                </button>
            </div>
        </ng-container>
    </div>
</div>
<div class="row mt-3">
    <div class="col-md-12">
        <ng-container *ngIf="!isLoading">
            <ng-container *ngIf="hasData?.visitorTreatmentInjections">
                <div class="overflow-auto pb-3">
                    <table class="table table-condensend table-striped">
                        <thead>
                            <tr>
                                <th class="p-3 text-center-important">#</th>
                                <ng-container *ngxPermissionsOnly="'cudVisitorTreatment'">
                                    <th class="p-3 text-center-important" *ngIf="!archived">{{ 'SHARED.ACTIONS' | translate }}</th>
                                </ng-container>
                                <ng-container *ngIf="!selfVisitor">
                                    <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.VISITOR' | translate }}</th>
                                </ng-container>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.NAME_AND_DOSAGE' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'FILTER.DATE_BEGIN' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'FILTER.DATE_END' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'FILTER.DATE_NEXT_INJECTION' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.REMARKS' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let visitorTreatmentInjection of visitorTreatmentInjections?.data; let i = index">
                                <td class="p-3 text-center-important" style="width: 70px;">{{ i + 1 }}</td>
                                <ng-container *ngxPermissionsOnly="'cudVisitorTreatment'">
                                    <td class="p-3 text-center-important td-actions"
                                        style="width: 100px;"
                                        *ngIf="!archived">
                                        <button type="button"
                                                class="btn btn-success btn-simple p-0"
                                                title="{{ 'VISITORS_MEDICAL.EDIT_TREATMENT_INJECTION' | translate }}"
                                                (click)="utilVisitorPartsTreatmentInjectionModalsAdd.openModal(visitor?.id, visitorTreatmentInjection)"
                                                appTooltip>
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button type="button"
                                                class="btn btn-danger btn-simple ml-3 p-0"
                                                title="{{ 'VISITORS_MEDICAL.DELETE_TREATMENT_INJECTION' | translate }}"
                                                (click)="delete(visitorTreatmentInjection)"
                                                appTooltip>
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="!selfVisitor">
                                    <td class="p-3 text-center-important">
                                        <a [routerLink]="['/visitor', visitorTreatmentInjection?.vId, 'infirmary', 'treatments']"
                                            class="text-primary">
                                            {{ visitorTreatmentInjection?.showName }}
                                        </a>
                                    </td>
                                </ng-container>
                                <td class="p-3 text-center-important" style="width: 300px;">
                                    <app-text-limit [text]="visitorTreatmentInjection?.medication_name" [limit]="30" [title]="'NAME_AND_DOSAGE'"></app-text-limit>
                                </td>
                                <td class="p-3 text-center-important" style="width: 120px;">
                                    {{ visitorTreatmentInjection?.date_begin | localizedDate | ifEmpty: '-' }}
                                </td>
                                <td class="p-3 text-center-important" style="width: 120px;">
                                    {{ visitorTreatmentInjection?.date_end | localizedDate | ifEmpty: '-'}}
                                </td>
                                <td class="p-3 text-center-important" style="width: 200px;">
                                    {{ visitorTreatmentInjection?.date_next_injection | localizedDate | ifEmpty: '-' }}
                                </td>
                                <td class="p-3 text-center-important">
                                    <app-text-limit [text]="visitorTreatmentInjection?.remarks" [title]="'REMARK'"></app-text-limit>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="align-items-center justify-content-center" *ngIf="visitorTreatmentInjections?.last_page > 1">
                        <app-pagination [data]="visitorTreatmentInjections" (switchPage)="switchPage($event)"></app-pagination>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!hasData?.visitorTreatmentInjections">
                <p>
                    {{ 'VISITORS_MEDICAL.NO_TREATMENT_INJECTION_FOUND' | translate }}
                </p>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isLoading">
            <p>
                <app-loading-spinner></app-loading-spinner>
            </p>
        </ng-container>
    </div>
</div>
<app-util-visitor-parts-treatment-injection-modals-add (addTreatmentEvent)="addTreatment()" #utilVisitorPartsTreatmentInjectionModalsAdd></app-util-visitor-parts-treatment-injection-modals-add>